import {Component, trigger, transition, style, animate, state, Input} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AdminService } from './../../../admin/services/admin.service';
import { PopupService } from './../../services/pop-up.service';
import { ErrorService } from './../../services/error.service';

@Component({
    selector: 'pop-up-reset-user-password',
    templateUrl: 'reset-user-password-popup.component.html',
    animations: [
    trigger(
      'popupAnimation',
      [
        transition(
        ':enter', [
          style({opacity: 0}),
          animate('300ms', style({'opacity': 1}))
        ]
      ),
      transition(
        ':leave', [
          style({'opacity': 1}),
          animate('300ms', style({'opacity': 0}))
        ]
      )]
    )
  ],
})

export class ResetUserPasswordPopupComponent {

    constructor(
        private _popupService: PopupService,
		private _adminService: AdminService,
		private _errorService: ErrorService
    ) {

    }

    ngOnInit(){
		this._adminService.resetResetUserData();
    }

    getResetPasswordFlag() {
        return this._popupService.getResetPasswordFlag();
	}
	
	getResetUserData(){
		return this._adminService.getResetUserData();
	}

	getBackEndError(){
		return this._errorService.getBackEndError();
	}

	isDisableSubmit(){
		return this._adminService.isDisableConfirmResetUser();
	}
	
	close(){
        this._popupService.closePopup();
        this._adminService.resetResetUserData();
	}
	
	confirmResetUser(){
		this._adminService.confirmResetUser();
	}

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/popup/reset-user-password-popup.component.ts